import { Button } from '@1trading/react';
import { SUBJECT_TYPE_LABELS } from '@/features/abuse/abuse-meta';
import { ABUSE_SUBJECT_TYPES, type AbuseSubjectType } from '@/services/api/abuse';

interface SubjectTypeTogglesProps {
  label: string;
  value: AbuseSubjectType;
  onChange: (value: AbuseSubjectType) => void;
}

export const SubjectTypeToggles = ({ label, value, onChange }: SubjectTypeTogglesProps) => (
  <fieldset aria-label={label} className="m-0 flex items-center gap-1 border-0 p-0">
    {ABUSE_SUBJECT_TYPES.map((type) => (
      <Button key={type} onClick={() => onChange(type)} size="sm" type="button" variant={value === type ? 'primary' : 'outline'}>
        {SUBJECT_TYPE_LABELS[type]}
      </Button>
    ))}
  </fieldset>
);
SubjectTypeToggles.displayName = 'SubjectTypeToggles';
